import axiosInstance from '../Api/axiosInstance';

export const getBranding = (subdomain) => {
	if (!subdomain) {
		return Promise.reject(new Error('Subdomain is required'));
	}
	return axiosInstance.get(`/branding/${subdomain}`);
};
